export default __webpack_public_path__ + "static/media/scholar-instructions-2.f53ce0aa.svg";